import React, { useState, useEffect } from 'react';

import { optionPropType } from '@vlabs/shared/types/propTypes';
import validate from '@vlabs/shared/validators';
import PropTypes from 'prop-types';
import { useWatch, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CheckboxCustomFilter } from '../components/checkbox-custom-filter/CheckboxCustomFilter';
import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { addOption, removeOption, normalizeGroupedOptions } from '../helpers';
import { useFilterCount } from '../hooks';

export const StreamIdsSelectPopover = ({
  streamIdsOptions,
  prefixName = '',
  onCountChange = undefined,
  ...props }) => {
  const { t } = useTranslation();
  const withPrefixName = (value) => [prefixName, value].filter(Boolean).join('.');

  const [allOptions, setAllOptions] = useState(streamIdsOptions);
  const [createdOptions, setCreatedOptions] = useState([]);
  const selectedStreamIds = useWatch({ name: withPrefixName('stream_ids') }) || [];
  const { control } = useFormContext();

  useEffect(() => {
    // при инициализации смотрим есть ли в форме уже добавленные опции
    const initialCreated = selectedStreamIds.filter(
      (option) => !streamIdsOptions.some((c) => c.value === option.value),
    );
    setCreatedOptions(normalizeGroupedOptions(initialCreated));
  }, []);

  useEffect(() => {
    const grouped = normalizeGroupedOptions(streamIdsOptions);
    setAllOptions([...createdOptions, ...grouped]);
  }, [createdOptions, streamIdsOptions]);

  const filterCount = Array.isArray(selectedStreamIds) && selectedStreamIds.length > 0 ? 1 : 0;
  useFilterCount('stream_ids', filterCount, onCountChange);

  const onCreateOption = (option) => {
    setCreatedOptions((prev) => addOption({
      createdOptions: prev,
      newOption: option,
    }),
    );
  };

  const onDeleteOption = (option) => {
    setCreatedOptions((prev) => removeOption({
      createdOptions: prev,
      newOption: option,
    }),
    );
  };

  return (
    <CustomFilterPopover
      hasFilterValue={Boolean(filterCount)}
      testId="streamIdsFilter"
      triggerValue={t('video stream')}
      {...props}
    >
      <CheckboxCustomFilter
        control={control}
        createdOptions={createdOptions}
        isCreatable
        isMulti
        isSearchable
        name={withPrefixName('stream_ids')}
        onCreateOption={onCreateOption}
        onDeleteOption={onDeleteOption}
        options={allOptions}
        validateProp={validate.uuid()}
      />
    </CustomFilterPopover>
  );
};

StreamIdsSelectPopover.propTypes = {
  streamIdsOptions: PropTypes.arrayOf(optionPropType).isRequired,
  prefixName: PropTypes.string,
  onCountChange: PropTypes.func,
};
